"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricType = void 0;
/**
 * Enumeration defining the metric types available. These match the types defined in the
 * <a href="https://github.com/OpenObservability/OpenMetrics/blob/main/specification/OpenMetrics.md">
 *     OpenMetrics specification.
 * </a>
 *
 * @since 6.10
 */
var MetricType;
(function (MetricType) {
    /**
     * Counters measure discrete events. Common examples are the number of HTTP requests received, CPU seconds
     * spent, or bytes sent. Counters are always monotonic, and are typically used to count events.
     */
    MetricType[MetricType["COUNTER"] = 0] = "COUNTER";
    /**
     * Gauges are current measurements, such as bytes of memory currently used or the number of items in a queue.
     */
    MetricType[MetricType["GAUGE"] = 1] = "GAUGE";
    /**
     * Info metrics are used to expose textual information which SHOULD NOT change during process lifetime.
     * Common examples are an application's version, revision control commit, and the version of a compiler.
     */
    MetricType[MetricType["INFO"] = 2] = "INFO";
    /**
     * Histograms measure distributions of discrete events. Common examples are the latency of HTTP requests,
     * function runtimes, or I/O request sizes.
     */
    MetricType[MetricType["HISTOGRAM"] = 3] = "HISTOGRAM";
    /**
     * GaugeHistograms measure current distributions. Common examples are how long items have been waiting in a
     * queue, or size of the requests in a queue.
     */
    MetricType[MetricType["GAUGE_HISTOGRAM"] = 4] = "GAUGE_HISTOGRAM";
    /**
     * StateSets represent a series of related boolean values, also called a bitset.
     */
    MetricType[MetricType["STATE_SET"] = 5] = "STATE_SET";
    /**
     * Like Histograms, Summaries measure distributions of discrete events and MAY be used when
     * Histograms are too expensive and/or an average event size is sufficient.
     */
    MetricType[MetricType["SUMMARY"] = 6] = "SUMMARY";
    /**
     * An unknown metric type.
     */
    MetricType[MetricType["UNKNOWN"] = 7] = "UNKNOWN";
})(MetricType = exports.MetricType || (exports.MetricType = {}));
